import SlimSelect from 'slim-select'
import 'slim-select/styles'
import { registerSelectMenuRefreshHandler } from '../../../shared/ts/select-menu/select-menu-refresh'
import { installFormValidation } from '../../../shared/ts/validate-form/install-form-validation'
import { validateField } from '../../../shared/ts/validate-form/validate-field'

const slimSelectInstances = new WeakMap<HTMLSelectElement, SlimSelect>()

const createSlimSelect = (element: HTMLSelectElement): SlimSelect => {
  const slim = new SlimSelect({
    select: element,
    settings: {
      showSearch: false,
    },
    events: {
      afterChange: () => {
        element.dispatchEvent(new Event('change', { bubbles: true }))
        validateField(element)
      },
    }
  })

  slimSelectInstances.set(element, slim)
  return slim
}

export const getSelectMenuInstance = (element: HTMLSelectElement): SlimSelect | undefined => {
  return slimSelectInstances.get(element)
}

export const initializeSelectMenu = () => {
  document.querySelectorAll<HTMLSelectElement>('select.selectmenu').forEach(createSlimSelect)

  const forms = document.querySelectorAll<HTMLFormElement>('form:has(.selectmenu)')
  for (const formElement of forms) {
    installFormValidation(formElement)
  }

  registerSelectMenuRefreshHandler((element) => {
    const existing = slimSelectInstances.get(element)
    if (existing) {
      existing.destroy()
    }
    createSlimSelect(element)
  })
}
